<template>
    <v-layout class="d-flex align-center justify-center rounded rounded-md">
        <v-container class="d-flex justify-center align-center fill-height">
            <v-app-bar app density="compact">
                <v-app-bar-nav-icon aria-label="Tunnel Twin">
                    <img src="/img/tunneltwin_favicon-300x300.png" alt="" width="24" height="24" />
                </v-app-bar-nav-icon>
                    <v-app-bar-title class="font-weight-medium">Tunnel Twin</v-app-bar-title>
                    <v-spacer></v-spacer>
                    <v-menu offset-y>
                        <template v-slot:activator="{ props }">
                            <v-btn v-bind="props" text>
                                {{ email }}
                                <v-icon right>mdi-menu-down</v-icon>
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item title="Profile" value="Profile" @click="onProfile" density="compact" prepend-icon="mdi-account-circle"/>
                                <v-list-item v-if="isAdmin" title="Create New Project" value="Create New Project" @click="onCreateProject" density="compact" prepend-icon="mdi-folder-plus-outline"/>
                                <v-list-item title="Logout" value="Logout" @click="onLogout" density="compact" prepend-icon="mdi-logout"/>
                                </v-list>
                    </v-menu>
                </v-app-bar>
                <v-main class="d-flex align-center justify-center" style="min-height: 300px; max-width: 800px;">
                    <v-container>
                        <v-row>
                            <v-col v-for="(project, index) in projects" cols="12">
                                <v-card
                                        :title="`${project.meta.name}`"
                                        :subtitle="`${project.meta.subtitle}`"
                                        :text="`${project.meta.description}`"
                                        @click="selectProject(index)"
                                        ></v-card>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-main>
        </v-container>
    </v-layout>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useCurrentUser, useFirestore, useFirebaseAuth, useCollection } from 'vuefire';
import { signOut } from '@firebase/auth';
import { collection, query, where } from '@firebase/firestore';
import { onProfile, onLogout, onCreateProject, isAdminEmail } from '/components/ttUtils';
import router from '../router';

const user = useCurrentUser();
const auth = useFirebaseAuth();
const email = auth?.currentUser?.email;
const db = useFirestore();

const isAdmin = ref(false);
if (email)
    isAdminEmail(db, email).then((v) => { isAdmin.value = v; }).catch(() => { isAdmin.value = false; });

const projects = useCollection(
    query(collection(db, 'projects'), where('meta.whiteList', 'array-contains', email)),
);

async function selectProject(index: number) {
    router.push("/viewer/" + projects.value[index].id);
};

</script>

<style scoped>
</style>
